import React, { Component } from 'react'
import { connect } from 'react-redux'

class Signatarios extends Component {

    render(){
        const { signatario } = this.props.documentos.historico
        return(
            <div style={{ width: '100%', padding: 15}}>
                {signatario && signatario.map( ( sig, index ) => {
                    const { nome, email, status, tipo } = sig
                    const tipoStyle = status.toLowerCase().search(/assinado|finalizado/gi) > -1 ? 'success' : 'warning'
                    const imgStatus = status.toLowerCase().search(/assinado|finalizado/gi) > -1 ? 'concluido.png' : status.toLowerCase().includes('cancelado') ? 'cancelado.png' : 'clock.png'  
                    return (
                        <div style={styles.container}>
                            <img src={`/assets/imagem/${imgStatus}`} style={{ width: 35 }} />
                            <div style={{ display:'grid', padding:'1%', marginLeft: 10 }}>
                                <span style={{ ...styles.text, fontWeight:'bold' }}>{nome}</span>
                                <span style={{ ...styles.text, color: 'gray', fontSize: 12, marginBottom: -1 }}>{tipo}</span>
                                <span style={{ ...styles.text, color: 'gray' }}>{email}</span>
                                <span className={`badge badge-pill badge-${tipoStyle}`} style={styles.status}>{status}</span>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}

const styles = {
    container: { borderTop: '1px solid #dee2e6', width: '100%',display:'flex',flexDirection:'row',alignItems:'center' },
    text: { 
        fontSize: 13,
        wordBreak:'break-word',
        width: '100%',
    },
    status:{ width: 'min-content', fontSize: 9,marginTop: 3,marginBottom: 3}
    
}

const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default connect(mapStateToProps, {
    
})(Signatarios);